import React from "react";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";

/**
 * A reusable breadcrumb component for page navigation
 * @param {Object} props
 * @param {Array<{label: string, href?: string}>} props.items - Array of breadcrumb items
 */
export default function PageBreadcrumbs({ items }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs separator="›">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast || !item.href) {
            return (
              <Typography key={item.label} color="text.primary">
                {item.label}
              </Typography>
            );
          }

          return (
            <Link
              key={item.label}
              href={item.href}
              underline="hover"
              color="inherit"
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
}
